module.exports = __webpack_public_path__ + "assets/img/22_1308_big.d681c61e.jpg";